export default {
  showLevelSelector: true,
  menuList: [],
  currentChapter: undefined,
  designChapter: undefined,
  drawerCollapsed: true,
  notebook: {
    title: "",
    description: "",
  },
};
